export class ReportTableTwo {

    /**
     *
     * @param values
     */
    constructor(values = null) {
        this.title = values?.title || '';

        this.academic_period = values?.academic_period || '';

        this.report_subtype = values?.report_subtype || '';

        this.report_type = values?.report_type || '';

        this.data_sources = values?.data_sources || [];
    }

    /**
     *
     * @returns {ReportTableTwo}
     */
    static build(values) {
        return new ReportTableTwo(values);
    }
}
